// extracted by mini-css-extract-plugin
module.exports = {"cell":"ShopperGroupIncentive_cell__3eegl","label":"ShopperGroupIncentive_label__3bo9f","value":"ShopperGroupIncentive_value__bbDQi"};